/**
 * Placeholder Handling for form text in form row inputs
 */

// INFO: As of 2024, this script is for the old Form Elements, which are to be replaced by the new ones (underline style)

(($) => {
    $(window).ready(function () {
        var FormTextInput = $(".form--row .form--text");

        FormTextInput
        .on('focus', function () {
            if (!$(this).hasClass('dirty')) {
                $(this).addClass('dirty');
                $(this).parent('.form--row').addClass('in');
            }
        }).on('blur', function () {
            if ($(this).hasClass('dirty') && $(this).val().toString() === '') {
                $(this).removeClass('dirty');
                $(this).parent('.form--row').removeClass('in');
            }
        });

        // init
        FormTextInput.each(function(){

            if ($(this).val().length > 0) {
                $(this).parent('.form--row').addClass('in');
            }
        });

    });

})( jQuery );
